import React from 'react';
import { THEMES } from '../constants';

const initialState = {
  theme: THEMES.DEFAULT,
  setTheme: (theme: string) => {}
};
const ThemeContext = React.createContext(initialState);

type ThemeProviderProps = {
  children: React.ReactNode;
};

function ThemeProvider({ children }: ThemeProviderProps) {
  const initialStates = () => {
    const storedTheme = localStorage.getItem('theme');

    return storedTheme ? JSON.parse(storedTheme) : THEMES.DEFAULT;
  };

  const [theme, _setTheme] = React.useState<string>(initialStates());

  const setTheme = (currTheme: string) => {
    localStorage.setItem('theme', JSON.stringify(currTheme));
    _setTheme(currTheme);
  };

  return <ThemeContext.Provider value={{ theme, setTheme }}>{children}</ThemeContext.Provider>;
}

export { ThemeProvider, ThemeContext };
